import { createContext } from 'react';

import { StudyGuardState } from './study-guard.model';

export const StudyGuardContext = createContext<StudyGuardState | undefined>(undefined);

StudyGuardContext.displayName = 'StudyGuardContext';
